import React, { useState } from "react";

interface ExportSelectProps {
  orders: any[];
  selectedDate: string;
  selectedDate2: string;
  handleExport: (type: string, orders: any[], startDate: string, endDate: string) => void;
}

const ExportSelect: React.FC<ExportSelectProps> = ({ orders, selectedDate, selectedDate2, handleExport }) => {
  const [selected, setSelected] = useState("Select");

  const handleChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelected(value);

    if (value !== "Select") {
      await handleExport(value, orders, selectedDate, selectedDate2);

      // ✅ Reset back to default after export
      setSelected("Select");
    }
  };

  return (
    <div className="2xl:order-none flex flex-col sm:flex-row sm:items-center sm:gap-2 col-span-1 sm:col-auto">
      <label className="text-lg whitespace-nowrap">Choose export file:</label>
      <select
        className="w-full sm:w-36 h-9 border border-blue-500 rounded-2xl px-2 outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-500 cursor-pointer;"
        value={selected}
        onChange={handleChange}
      >
        <option value="Select" disabled>
          Select
        </option>
        <option value="CSV">CSV</option>
        <option value="PDF">PDF</option>
      </select>
    </div>
  );
};

export default ExportSelect;
